import { Route, Waves, Activity, Timer } from "lucide-react";

export const SCORE_ITEMS = [
  { label: "Turns", key: "turns", icon: Route, color: "bg-sky-500", weight: 35 },
  { label: "Smoothness", key: "smoothness", icon: Waves, color: "bg-yellow-500", weight: 25 },
  { label: "Stability", key: "stability", icon: Activity, color: "bg-emerald-500", weight: 25 },
  { label: "Time", key: "time", icon: Timer, color: "bg-violet-500", weight: 15 },
];

/** Accepts unix seconds or ms. */
export function toMs(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n > 1e11 ? n : n * 1000;
}

export function formatDateTime(v) {
  const ms = toMs(v) ?? (typeof v === "string" ? Date.parse(v) : null);
  if (!ms || Number.isNaN(ms)) return "—";
  return new Date(ms).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}

export function formatDate(v) {
  const ms = toMs(v) ?? (typeof v === "string" ? Date.parse(v) : null);
  if (!ms || Number.isNaN(ms)) return "—";
  return new Date(ms).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" });
}

export function formatDuration(ms) {
  const n = Number(ms);
  if (!Number.isFinite(n) || n <= 0) return "—";
  const s = n / 1000;
  if (s < 60) return `${s.toFixed(1)} s`;
  return `${Math.floor(s / 60)}m ${Math.round(s % 60)}s`;
}

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

/** Map a getTestResults summary into the dashboard row shape. */
export function mapTestSummary(r) {
  const c = r.candidate || {};
  const id = r.testId || r.id;
  const name = c.name || `Test ${id}`;
  return {
    id,
    name,
    age: c.age ?? null,
    licenseType: c.licenseType || null,
    vehicleType: c.vehicleType || null,
    testCenter: c.testCenter || null,
    rfid: r.rfid || null,
    status: r.status || null,
    start: r.start,
    stop: r.stop,
    startMs: r.startMs || toMs(r.start),
    durationMs: r.durationMs,
    sampleCount: r.sampleCount,
    isReference: !!r.isReference,
    testDate: r.startMs ? new Date(r.startMs).toISOString() : r.evaluatedAt || "",
    photoSeed: initials(name),
    sensorData: r.sensorMetrics || {},
    scores: r.scores || {},
    failures: r.failures || [],
    overallScore: r.overallScore || 0,
    result: r.isReference ? "REFERENCE" : r.result || "PENDING",
    state: r.state,
    certificateUrl: r.certificateUrl || null,
    evaluatedAt: r.evaluatedAt,
  };
}

export const fmtNum = (v, d = 2) => (Number.isFinite(Number(v)) ? Number(v).toFixed(d) : "—");
